import type { PointerEvent as ReactPointerEvent } from 'react';

import { useSetOverlayState } from './store/use-set-overlay-state.js';

export const useOverlayHandlers = () => {
  const { setOverlayStateInBounds } = useSetOverlayState();

  const onPointerEnterHandler = () => {
    setOverlayStateInBounds(true);
  };

  const onPointerLeaveHandler = (event: ReactPointerEvent) => {
    if (event.pointerType !== 'touch') {
      setOverlayStateInBounds(false);
    }
  };

  return {
    onPointerEnterHandler,
    onPointerLeaveHandler,
  };
};
